import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-are-you-sure',
  templateUrl: './are-you-sure.component.html',
  styleUrls: ['./are-you-sure.component.scss'],
  imports: [CardComponent, MatButton, MatDialogClose, MatIcon],
})
export class AreYouSureComponent {
  result: boolean;
  dialogRef = inject(MatDialogRef<AreYouSureComponent>);
  data: { text: string } = inject(MAT_DIALOG_DATA);
}
